<app-multi-select-tree-view-drop-down
[dataSource]="placeLookUp"
[enableRequiredValidation]="true"
requiredValidationMessage = "{{'Place Required'|translate}}"
[(dropDownSelection)]="selectedPlaces"
(dropDownSelectionChange)="placesChanged($event)">
</app-multi-select-tree-view-drop-down>